import { useEffect } from 'react';
import type { MutableRefObject } from 'react';

import { MNHotInstance, MNHotProps } from '../tableHotInstanceTypes';
import { isHotInstanceAvailable } from '../utils/hotInstanceUtils/hotTableInstanceValidationUtils';

type UseSyncHotMilanotePropsArgs = {
    milanoteProps: MNHotProps;
    hotTableInstanceRef: MutableRefObject<MNHotInstance | null>;
};

/**
 * Keeps Milanote props synced to hotInstance.milanoteProps, which might be used by HOT plugins
 */
export const useSyncHotMilanoteProps = ({ milanoteProps, hotTableInstanceRef }: UseSyncHotMilanotePropsArgs): void => {
    useEffect(() => {
        const hotInstance = hotTableInstanceRef.current;
        if (!isHotInstanceAvailable(hotInstance)) return;

        hotInstance.milanoteProps = {
            ...hotInstance.milanoteProps,
            ...milanoteProps,
        };
    }, [hotTableInstanceRef, ...Object.values(milanoteProps)]);
};

export default useSyncHotMilanoteProps;
